import React from 'react'
const AdminPage = () => (
    <div>
        <h3>Admin</h3>
    </div>
)

export default AdminPage



// WEBPACK FOOTER //
// ./src/pages/AdminPage.js